module.exports = __webpack_public_path__ + "img/HZMB_FIRST_COMPANY.f3a823f0.png";